module.exports = __webpack_public_path__ + "img/PressCenter.4ca12983.jpg";